export default __webpack_public_path__ + "static/media/lr.f0ecfce5.svg";